// ============================================
// NOTIFICATION SERVICE - API calls for in-app notifications
// ============================================

import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

function getHeaders() {
  const token = localStorage.getItem('accessToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

export interface Notification {
  id: string;
  userId: string;
  type: string;
  title: string;
  message: string;
  relatedPostId?: string;
  relatedCommentId?: string;
  relatedUserId?: string;
  relatedConversationId?: string;
  actionUrl?: string;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
}

export interface NotificationsResponse {
  notifications: Notification[];
  unreadCount: number;
  pagination: {
    page: number;
    limit: number;
    totalCount: number;
    totalPages: number;
    hasMore: boolean;
  };
}

export const notificationService = {
  // Get notifications list
  async getNotifications(page: number = 1, limit: number = 20): Promise<NotificationsResponse> {
    const response = await axios.get(
      `${API_URL}/api/notifications?page=${page}&limit=${limit}`,
      { headers: getHeaders() }
    );
    return response.data;
  },

  // Get unread count
  async getUnreadCount(): Promise<number> {
    const response = await axios.get(
      `${API_URL}/api/notifications/unread-count`,
      { headers: getHeaders() }
    );
    return response.data.unreadCount;
  },

  // Mark notification as read
  async markAsRead(notificationId: string): Promise<void> {
    await axios.put(
      `${API_URL}/api/notifications/${notificationId}/read`,
      {},
      { headers: getHeaders() }
    );
  },

  // Mark all as read
  async markAllAsRead(): Promise<void> {
    await axios.put(
      `${API_URL}/api/notifications/read-all`,
      {},
      { headers: getHeaders() }
    );
  }
};
